import { ErrorBoundary } from 'react-error-boundary';
import { IChainInfo } from '@kattana-io/common';
import ChainPairsTable from './ChainPairsTable';
import ChainSidebar from '../../components/SEO/Sidebar';
import ChainAbout from '../../components/SEO/About';
import { getChainStatistics } from './helpers';
import Fallback from '../../components/Fallback';

interface IChainProps {
  chain: IChainInfo;
  slug: string;
  title: string;
  logo: string;
  timezone?: string;
}

const Chain = ({ chain, slug, title, logo, timezone }: IChainProps) => {
  return (
    <div className='seo_page__content'>
      <div className='seo_page__about_token'>
        <div className='seo_page__main'>
          <ErrorBoundary
            fallbackRender={(props) => (
              <Fallback
                {...props}
                className='seo_page__about_token__content'
                title='About Chain Section'
              />
            )}
            onReset={(details) => {
              // Reset the state of your app so the error doesn't happen again
            }}
          >
            <ChainAbout
              title={title}
              subTitle={slug}
              slug={slug}
              description={`${title} is a highly scalable blockchain platform for DeFi, crypto dApps, and enterprise applications.`}
              logo={logo}
            />
          </ErrorBoundary>
          <ErrorBoundary
            fallbackRender={(props) => (
              <Fallback
                {...props}
                className='seo_page__sidebar'
                title='Sidebar'
              />
            )}
            onReset={(details) => {
              // Reset the state of your app so the error doesn't happen again
            }}
          >
            <ChainSidebar
              statisticsTitle={`${slug} Chain Statistics`}
              slug={slug}
              statistics={getChainStatistics(chain.chain, timezone)}
            />
          </ErrorBoundary>
        </div>
      </div>
      <ErrorBoundary
        fallbackRender={(props) => (
          <Fallback
            {...props}
            className='seo_page__table'
            title='Chain Pairs Table'
          />
        )}
        onReset={(details) => {
          // Reset the state of your app so the error doesn't happen again
        }}
      >
        <ChainPairsTable pairs={Object.values(chain.pairs)} />
      </ErrorBoundary>
    </div>
  );
};

export default Chain;
